import { useOrganizationList } from "@clerk/react";

import { AuthScreen } from "@/components/auth/auth-screen";
import { redirectAfterAuth } from "@/lib/auth-helpers";

const ChooseOrganizationPage = () => {
  const { isLoaded, setActive, userMemberships } = useOrganizationList({
    userMemberships: { infinite: true },
  });

  return (
    <AuthScreen
      subtitle="Select the workspace to continue."
      title="Choose organization"
    >
      {isLoaded ? (
        <ul className="m-0 flex list-none flex-col gap-2 p-0">
          {(userMemberships.data ?? []).map((membership) => (
            <li key={membership.id}>
              <button
                className="auth-focus h-[52px] w-full rounded-[10px] border border-n-200 bg-white px-4 text-left font-medium text-base"
                onClick={() => {
                  setActive({
                    organization: membership.organization.id,
                  })
                    .then(() => {
                      window.location.assign(redirectAfterAuth());
                    })
                    .catch(() => undefined);
                }}
                type="button"
              >
                {membership.organization.name}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-n-600">Loading</p>
      )}
    </AuthScreen>
  );
};

export default ChooseOrganizationPage;
